var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getSdaData } from "../utils/getSdaData.function";
import { ComputeBudgetProgram, SYSVAR_INSTRUCTIONS_PUBKEY, SystemProgram, } from "@solana/web3.js";
import { findOrCreateAta } from "../utils/findOrCreateAta.function";
import { TOKEN_2022_PROGRAM_ID, TOKEN_PROGRAM_ID } from "@solana/spl-token";
import { METAPLEX_AUTH_RULES_PROGRAM, SOLANA_SPL_ATA_PROGRAM_ID, TOKEN_METADATA_PROGRAM, VERSION, } from "../utils/const";
import { findNftDataAndMetadataAccount, findPnftAccounts, getCoreCollection, whichStandard, } from "../utils/findNftDataAndAccounts.function";
import { TokenStandard } from "@metaplex-foundation/mpl-token-metadata";
import { DESC } from "../utils/descriptions";
import { checkEnvOpts, getClaimSArgs } from "../utils/check";
import { ix2vTx } from "../utils/vtx";
import { closeWSol } from "../utils/wsol";
import { WRAPPED_SOL_MINT } from "@metaplex-foundation/js";
import { MPL_CORE_PROGRAM_ID } from "@metaplex-foundation/mpl-core";
export function createCancelSwapInstructions(Data) {
    return __awaiter(this, void 0, void 0, function () {
        var cEnvOpts, ClaimSArgs, program, connection, signer, swapDataAccount, instructions, swapDataData, paymentMint, maker, nftMintMaker, _a, swapDataAccountTokenAta, sdaT, _b, makerTokenAta, mT, tknStd, collection, cancelIxs, _c, makerNftAta, mN, _d, swapDataAccountNftAta, sdaN, nftMasterEditionMaker, ownerTokenRecordMaker, destinationTokenRecordMaker, authRulesMaker, _e, nftMetadataMaker, tokenStandardMaker, cancelIx, cancelIx, error_1;
        var _f, _g;
        return __generator(this, function (_h) {
            switch (_h.label) {
                case 0:
                    console.log(VERSION);
                    return [4 /*yield*/, checkEnvOpts(Data)];
                case 1:
                    cEnvOpts = _h.sent();
                    ClaimSArgs = getClaimSArgs(Data);
                    program = cEnvOpts.program, connection = cEnvOpts.connection;
                    signer = ClaimSArgs.signer, swapDataAccount = ClaimSArgs.swapDataAccount;
                    instructions = [
                        ComputeBudgetProgram.setComputeUnitLimit({
                            units: 800000,
                        }),
                    ];
                    _h.label = 2;
                case 2:
                    _h.trys.push([2, 22, , 23]);
                    return [4 /*yield*/, getSdaData({
                            program: program,
                            swapDataAccount: swapDataAccount,
                        })];
                case 3:
                    swapDataData = _h.sent();
                    if (!swapDataData)
                        throw "no swapData found at " + swapDataAccount;
                    paymentMint = swapDataData.paymentMint, maker = swapDataData.maker, nftMintMaker = swapDataData.nftMintMaker;
                    return [4 /*yield*/, findOrCreateAta({
                            connection: connection,
                            mint: paymentMint,
                            owner: swapDataAccount,
                            signer: signer,
                        })];
                case 4:
                    _a = _h.sent(), swapDataAccountTokenAta = _a.mintAta, sdaT = _a.instruction;
                    if (sdaT) {
                        console.log("adding swapDataAccountTokenAta", swapDataAccountTokenAta.toString());
                        instructions.push(sdaT);
                    }
                    return [4 /*yield*/, findOrCreateAta({
                            connection: connection,
                            mint: paymentMint,
                            owner: maker,
                            signer: signer,
                        })];
                case 5:
                    _b = _h.sent(), makerTokenAta = _b.mintAta, mT = _b.instruction;
                    if (mT) {
                        console.log("adding makerTokenAta", makerTokenAta.toString());
                        instructions.push(mT);
                    }
                    return [4 /*yield*/, whichStandard({ connection: connection, mint: nftMintMaker })];
                case 6:
                    tknStd = _h.sent();
                    console.log(" tknD", tknStd);
                    if (!(tknStd === "core")) return [3 /*break*/, 9];
                    return [4 /*yield*/, getCoreCollection({ connection: connection, mint: nftMintMaker })];
                case 7:
                    collection = _h.sent();
                    return [4 /*yield*/, program.methods
                            .cancelSwapCore()
                            .accountsStrict({
                            collection: collection,
                            coreProgram: MPL_CORE_PROGRAM_ID,
                            maker: maker,
                            makerTokenAta: makerTokenAta,
                            nftMintMaker: nftMintMaker,
                            paymentMint: paymentMint,
                            signer: signer,
                            swapDataAccount: swapDataAccount,
                            swapDataAccountTokenAta: swapDataAccountTokenAta,
                            systemProgram: SystemProgram.programId,
                            tokenProgram: TOKEN_PROGRAM_ID,
                        })
                            .instruction()];
                case 8:
                    cancelIxs = _h.sent();
                    instructions.push(cancelIxs);
                    return [3 /*break*/, 19];
                case 9: return [4 /*yield*/, findOrCreateAta({
                        connection: connection,
                        mint: nftMintMaker,
                        owner: maker,
                        signer: signer,
                    })];
                case 10:
                    _c = _h.sent(), makerNftAta = _c.mintAta, mN = _c.instruction;
                    if (mN) {
                        console.log("adding makerNftAta", makerNftAta.toString());
                        instructions.push(mN);
                    }
                    return [4 /*yield*/, findOrCreateAta({
                            connection: connection,
                            mint: nftMintMaker,
                            owner: swapDataAccount,
                            signer: signer,
                        })];
                case 11:
                    _d = _h.sent(), swapDataAccountNftAta = _d.mintAta, sdaN = _d.instruction;
                    if (sdaN) {
                        console.log("adding swapDataAccountNftAta", swapDataAccountNftAta.toString());
                        instructions.push(sdaN);
                    }
                    if (!(tknStd == "native")) return [3 /*break*/, 16];
                    nftMasterEditionMaker = signer;
                    ownerTokenRecordMaker = signer;
                    destinationTokenRecordMaker = signer;
                    authRulesMaker = signer;
                    return [4 /*yield*/, findNftDataAndMetadataAccount({
                            connection: connection,
                            mint: nftMintMaker,
                        })];
                case 12:
                    _e = _h.sent(), nftMetadataMaker = _e.metadataAddress, tokenStandardMaker = _e.tokenStandard;
                    console.log("nftMetadataMaker", nftMetadataMaker);
                    if (!(tokenStandardMaker == TokenStandard.ProgrammableNonFungible)) return [3 /*break*/, 14];
                    return [4 /*yield*/, findPnftAccounts({
                            connection: connection,
                            ownerAta: swapDataAccountNftAta,
                            mint: nftMintMaker,
                            destinationAta: makerNftAta,
                        })];
                case 13:
                    (_f = _h.sent(), authRulesMaker = _f.authRules, destinationTokenRecordMaker = _f.destinationTokenRecord, nftMasterEditionMaker = _f.masterEdition, ownerTokenRecordMaker = _f.ownerTokenRecord);
                    _h.label = 14;
                case 14: return [4 /*yield*/, program.methods
                        .cancelSwap()
                        .accountsStrict({
                        signer: signer,
                        swapDataAccount: swapDataAccount,
                        swapDataAccountNftAta: swapDataAccountNftAta,
                        swapDataAccountTokenAta: swapDataAccountTokenAta,
                        maker: maker,
                        makerNftAta: makerNftAta,
                        makerTokenAta: makerTokenAta,
                        nftMintMaker: nftMintMaker,
                        paymentMint: paymentMint,
                        nftMetadataMaker: nftMetadataMaker,
                        nftMasterEditionMaker: nftMasterEditionMaker,
                        ownerTokenRecordMaker: ownerTokenRecordMaker,
                        destinationTokenRecordMaker: destinationTokenRecordMaker,
                        authRulesMaker: authRulesMaker,
                        systemProgram: SystemProgram.programId,
                        metadataProgram: TOKEN_METADATA_PROGRAM,
                        sysvarInstructions: SYSVAR_INSTRUCTIONS_PUBKEY,
                        tokenProgram: TOKEN_PROGRAM_ID,
                        ataProgram: SOLANA_SPL_ATA_PROGRAM_ID,
                        authRulesProgram: METAPLEX_AUTH_RULES_PROGRAM,
                    })
                        .instruction()];
                case 15:
                    cancelIx = _h.sent();
                    console.log("adding native cancelIx");
                    instructions.push(cancelIx);
                    return [3 /*break*/, 19];
                case 16:
                    if (!(tknStd == "hybrid")) return [3 /*break*/, 18];
                    return [4 /*yield*/, program.methods
                            .cancelSwap22()
                            .accountsStrict({
                            signer: signer,
                            swapDataAccount: swapDataAccount,
                            swapDataAccountNftAta: swapDataAccountNftAta,
                            swapDataAccountTokenAta: swapDataAccountTokenAta,
                            maker: maker,
                            makerNftAta: makerNftAta,
                            makerTokenAta: makerTokenAta,
                            nftMintMaker: nftMintMaker,
                            paymentMint: paymentMint,
                            systemProgram: SystemProgram.programId,
                            tokenProgram: TOKEN_PROGRAM_ID,
                            tokenProgram22: TOKEN_2022_PROGRAM_ID,
                            ataProgram: SOLANA_SPL_ATA_PROGRAM_ID,
                        })
                            .instruction()];
                case 17:
                    cancelIx = _h.sent();
                    console.log("adding hybrid cancelIx");
                    instructions.push(cancelIx);
                    return [3 /*break*/, 19];
                case 18: throw "unsupported token standard";
                case 19:
                    if (swapDataData.paymentMint === WRAPPED_SOL_MINT.toString() && signer == maker)
                        instructions.push(closeWSol(maker, maker, makerTokenAta));
                    _g = {};
                    return [4 /*yield*/, ix2vTx(instructions, cEnvOpts, signer)];
                case 20:
                    _g.tx = _h.sent(),
                        _g.description = DESC.cancelSwap,
                        _g.details = Data,
                        _g.priority = 0;
                    return [4 /*yield*/, connection.getLatestBlockhash()];
                case 21: return [2 /*return*/, (_g.blockheight = (_h.sent()).lastValidBlockHeight,
                        _g.status = "pending",
                        _g)];
                case 22:
                    error_1 = _h.sent();
                    throw {
                        blockchain: "solana",
                        status: "error",
                        message: error_1,
                        swapDataAccount: swapDataAccount,
                    };
                case 23: return [2 /*return*/];
            }
        });
    });
}
